'use client';

import ReactDOM from 'react-dom';
import Env from '../environmentVariables/EnvironmentVariables';
import { getRpcOptions } from '../utils/rpc';
import { GEOLOCATION_URL } from '../constants/constants';

// Pre-Connecting to these URLs should speed up the time it takes to do the initial requests to them (and therefore the overall time the page takes to load)
// See https://nextjs.org/docs/app/api-reference/functions/generate-metadata#resource-hints for more details
export function PreloadResources(): null {
	const rpcOptions = getRpcOptions(
		Env.sdkEnv === 'mainnet-beta' ? 'mainnet-beta' : 'devnet'
	);

	ReactDOM.preconnect(Env.dataApiUrl);
	ReactDOM.preconnect(Env.dlobWsServerToUse);
	ReactDOM.preconnect(Env.dlobServerHttpUrl);
	ReactDOM.preconnect(GEOLOCATION_URL);
	rpcOptions.forEach((rpcOption) => {
		ReactDOM.preconnect(rpcOption.value);
	});

	return null;
}
